module.exports = __webpack_public_path__ + "img/comment2.c8bf9307.png";